import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{ minHeight:'70vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'2rem', textAlign:'center' }}>
      <div style={{ fontSize:'6rem', marginBottom:'1rem' }}>🔍</div>
      <h1 style={{ fontSize:'clamp(3rem,8vw,6rem)', fontWeight:900, color:'var(--border)', lineHeight:1 }}>404</h1>
      <h2 style={{ fontSize:'1.4rem', fontWeight:700, marginTop:'0.5rem' }}>Page Not Found</h2>
      <p style={{ color:'var(--text-secondary)', marginTop:'0.5rem', marginBottom:'1.5rem' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div style={{ display:'flex', gap:'0.75rem' }}>
        <Link to="/" className="btn btn-primary btn-lg">🏠 Go Home</Link>
        <Link to="/products" className="btn btn-outline btn-lg">🛍️ Browse Products</Link>
      </div>
    </div>
  );
}
